// Centralised data-testid registry for stable testing.

export const HOME = {
  emergentLink: "home-emergent-link",
  headerLogo: "home-header-logo",
  taglineBanner: "home-tagline-banner",
  forkZimBtn: "fork-zim-btn",
  forkSponsorBtn: "fork-sponsor-btn",
  forkPartnersBtn: "fork-partners-btn",
};

export const ZIM = {
  view: "zim-view",
  back: "zim-back-btn",
  heroBanner: "zim-hero-banner",
  cardPayg: "zim-card-payg",
  cardBundle: "zim-card-bundle",
  ctaPayg: "zim-cta-payg",
  ctaBundle: "zim-cta-bundle",
  stickyCta: "zim-sticky-cta",
};

export const SPONSOR = {
  view: "sponsor-view",
  back: "sponsor-back-btn",
  heroBanner: "sponsor-hero-banner",
  cardSingle: "sponsor-card-single",
  cardBundle: "sponsor-card-bundle",
  cardDonate: "sponsor-card-donate",
  ctaSingle: "sponsor-cta-single",
  ctaBundle: "sponsor-cta-bundle",
  ctaDonate: "sponsor-cta-donate",
  stickyCta: "sponsor-sticky-cta",
};

export const INTAKE = {
  modal: "intake-modal",
  firstName: "intake-first-name",
  contactNumber: "intake-contact-number",
  email: "intake-email",
  contactPrefWa: "intake-contact-pref-whatsapp",
  contactPrefRegular: "intake-contact-pref-regular",
  location: "intake-location",
  bookingFor: "intake-booking-for",
  relativeName: "intake-relative-name",
  relativeContact: "intake-relative-contact",
  preferredBundle: "intake-preferred-bundle",
  keepInformed: "intake-keep-informed-checkbox",
  suitability: "intake-suitability-checkbox",
  submit: "intake-submit-btn",
  close: "intake-close-btn",
  offlineBanner: "intake-offline-banner",
  successMessage: "intake-success-message",
  errorMessage: "intake-error-message",
};

export const PARTNERS = {
  view: "partners-view",
  back: "partners-back-btn",
  tierBronze: "partners-tier-bronze",
  tierSilver: "partners-tier-silver",
  tierGold: "partners-tier-gold",
  form: "partners-form",
  name: "partners-form-name",
  business: "partners-form-business",
  email: "partners-form-email",
  optBronze: "partners-form-opt-bronze",
  optSilver: "partners-form-opt-silver",
  optGold: "partners-form-opt-gold",
  optCustom: "partners-form-opt-custom",
  message: "partners-form-message",
  other: "partners-form-other",
  submit: "partners-form-submit",
  success: "partners-form-success",
  errorMessage: "partners-form-error",
};

export const FOOTER = {
  root: "site-footer",
  emailLink: "footer-email-link",
  whatsappLink: "footer-whatsapp-link",
  privacyLink: "footer-privacy-link",
  cookiesLink: "footer-cookies-link",
};

export const INTAKE_CONSENT = {
  dataUse: "intake-consent-data-use",
  dataSharing: "intake-consent-data-sharing",
  rightsAck: "intake-consent-rights-ack",
};

export const APP = {
  offlineBanner: "app-offline-banner",
  pendingSyncCount: "app-pending-sync-count",
};
